// extracted by mini-css-extract-plugin
module.exports = {"list":"GridBlock_list__oCTUQ","title":"GridBlock_title__m5_UN","empty":"GridBlock_empty__RnVdu","wrapper":"GridBlock_wrapper__RB_8S","button":"GridBlock_button__oLvlg"};